module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/customer-segments/customer-segments.component.scss
// module id = ./src/app/modules/customer-segments/customer-segments.component.scss
// module chunks = main